import { render, staticRenderFns } from "./PhoneEditor.vue?vue&type=template&id=bcb7a5c0"
import script from "./PhoneEditor.vue?vue&type=script&lang=js"
export * from "./PhoneEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports